export default "__VITE_ASSET__CS33VN4j__$_?nuxt_component=async&nuxt_component_name=SvgoBeach&nuxt_component_export=default__"